var installedModules = {};
var moduleToHandlerMapping = {
	20: {
		getter: () => (__webpack_require__.e(4510).then(() => (() => (__webpack_require__(4510))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.55.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	35: {
		getter: () => (__webpack_require__.e(7552).then(() => (() => (__webpack_require__(7552))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.0.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	40: {
		getter: () => (__webpack_require__.e(2215).then(() => (() => (__webpack_require__(2215))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	910: {
		getter: () => (__webpack_require__.e(7114).then(() => (() => (__webpack_require__(4733))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/design-system",
	},
	1279: {
		getter: () => (__webpack_require__.e(6853).then(() => (() => (__webpack_require__(6853))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^11.1.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "swiper/modules",
	},
	1964: {
		getter: () => (__webpack_require__.e(9210).then(() => (() => (__webpack_require__(9210))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/store",
	},
	2016: {
		getter: () => (__webpack_require__.e(1822).then(() => (() => (__webpack_require__(9441))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/utils",
	},
	2198: {
		getter: () => (__webpack_require__.e(1817).then(() => (() => (__webpack_require__(4198))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.6.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "embla-carousel-react",
	},
	3089: {
		getter: () => (__webpack_require__.e(4957).then(() => (() => (__webpack_require__(4957))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vanilla-extract/dynamic",
	},
	5013: {
		getter: () => (__webpack_require__.e(9119).then(() => (() => (__webpack_require__(9119))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "he",
	},
	5701: {
		getter: () => (__webpack_require__.e(5106).then(() => (() => (__webpack_require__(2725))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-error-boundary",
	},
	6600: {
		getter: () => (__webpack_require__.e(4868).then(() => (() => (__webpack_require__(4868))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/types",
	},
	6914: {
		getter: () => (__webpack_require__.e(4474).then(() => (() => (__webpack_require__(2093))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/hooks",
	},
	6927: {
		getter: () => (__webpack_require__.e(2981).then(() => (() => (__webpack_require__(2981))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.11.13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	7020: {
		getter: () => (__webpack_require__.e(1531).then(() => (() => (__webpack_require__(1531))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.33.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "es-toolkit",
	},
	7640: {
		getter: () => (__webpack_require__.e(6909).then(() => (() => (__webpack_require__(6909))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/constants",
	},
	7762: {
		getter: () => (__webpack_require__.e(1501).then(() => (() => (__webpack_require__(1501))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.120.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-router",
	},
	7885: {
		getter: () => (__webpack_require__.e(866).then(() => (() => (__webpack_require__(8485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.0.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	8977: {
		getter: () => (__webpack_require__.e(4357).then(() => (() => (__webpack_require__(4357))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "clsx",
	},
	9014: {
		getter: () => (__webpack_require__.e(4774).then(() => (() => (__webpack_require__(2393))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "zustand",
	},
	9286: {
		getter: () => (__webpack_require__.e(5049).then(() => (() => (__webpack_require__(5049))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uuid",
	},
	9846: {
		getter: () => (__webpack_require__.e(1435).then(() => (() => (__webpack_require__(1435))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@oy-global-web/analytics",
	},
	5989: {
		getter: () => (__webpack_require__.e(6963).then(() => (() => (__webpack_require__(6963))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	9340: {
		getter: () => (Promise.all([__webpack_require__.e(8281), __webpack_require__.e(6973)]).then(() => (() => (__webpack_require__(8281))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "qs",
	},
	9721: {
		getter: () => (__webpack_require__.e(7519).then(() => (() => (__webpack_require__(7519))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dompurify",
	},
	2900: {
		getter: () => (__webpack_require__.e(7792).then(() => (() => (__webpack_require__(7792))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.6.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "embla-carousel",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"35": [
		35
	],
	"1817": [
		2900
	],
	"1822": [
		5989,
		7020,
		9340,
		9721
	],
	"1879": [
		35,
		7885
	],
	"2093": [
		20,
		35,
		1964,
		2016,
		6600,
		7640
	],
	"2393": [
		35
	],
	"2725": [
		35
	],
	"2861": [
		20,
		35,
		40,
		910,
		1279,
		1964,
		2016,
		2198,
		3089,
		5013,
		5701,
		6600,
		6914,
		6927,
		7020,
		7640,
		7762,
		7885,
		8977,
		9014,
		9286,
		9846
	],
	"4198": [
		35,
		2900
	],
	"4733": [
		1964
	],
	"5470": [
		35,
		7885
	],
	"8485": [
		35
	],
	"9210": [
		35,
		2016,
		9014
	],
	"9441": [
		35,
		5989,
		7020,
		9340,
		9721
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}